import ScreenshotAccessBlock from './ScreenshotAccessBlock';

export default ScreenshotAccessBlock;
